/** Pure helpers for Deal Types keys / slot kinds. */
export type OpsDealTypeSlotKind =
  | "required_upload"
  | "reference_doc"
  | "give"
  | "sign_out"
  | "return_upload";

export type PaperworkBlock = "give" | "sign_out" | "return";

export const OPS_DEAL_TYPE_SLOT_KINDS: ReadonlyArray<OpsDealTypeSlotKind> = [
  "give",
  "sign_out",
  "return_upload",
  "reference_doc",
  "required_upload",
];

export function slugifyDealTypeKey(displayName: string): string {
  const raw = displayName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 64);
  return raw || "type";
}

export function isOpsDealTypeSlotKind(v: unknown): v is OpsDealTypeSlotKind {
  return (
    v === "required_upload" ||
    v === "reference_doc" ||
    v === "give" ||
    v === "sign_out" ||
    v === "return_upload"
  );
}

/** Map slot kinds onto Give / Sign-out / Return. Legacy kinds stay valid. */
export function paperworkBlockOfSlotKind(kind: OpsDealTypeSlotKind): PaperworkBlock {
  if (kind === "sign_out") return "sign_out";
  if (kind === "give" || kind === "reference_doc") return "give";
  return "return";
}

export function slotKindLabel(kind: OpsDealTypeSlotKind): string {
  if (kind === "give") return "Give (no signed copy back)";
  if (kind === "sign_out") return "Sign-out (expect signed return)";
  if (kind === "return_upload") return "Return upload";
  if (kind === "reference_doc") return "Reference doc (Give)";
  return "Required upload (Return)";
}
